import { render, staticRenderFns } from "./Computador.vue?vue&type=template&id=18c795aa&"
import script from "./Computador.vue?vue&type=script&lang=js&"
export * from "./Computador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports